export default __webpack_public_path__ + "static/P_SearchThumb_IN-8015HD-c121ac10efc2d3d5502a3578dc10f686.webp";